import React, { useState } from 'react'
import Header from '../../components/resturaunt-wineries/header'

import ResturantListing from '../../components/resturaunt-wineries/ResturantListing'

function Index() {
  const [selectedFilter, setSelectedFilter] = useState(null);
  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
  };

  return (
    <div>
        <Header getFilterData={handleFilterChange} />
        <ResturantListing selectedFilter={selectedFilter}  />

    </div>
  )
}

export default Index